<template>
  <div>
    <protocol-header v-if="protocol" :protocol="protocol"></protocol-header>

    <hr>

    <div class="row">
      <div class="col-12 mt-3">
        <div class="card card-fluid mb-3">
          <div class="card-body ">
            <a class="mr-2 btn btn-link btn-lg"
               :href="protocol.fulltext_file ? `/${protocol.fulltext_file.path}` : '#'"
               download
               target="_blank">
              <i class="fas fa-file-pdf text-red mr-2"></i> Descargar protocol en formato PDF.
            </a>

            <a class="mr-2 btn btn-link btn-lg"
               :href="`/protocolo/${protocol.id}/consultar`">
              <i class="fas fa-external-link-alt mr-2"></i> Ver datos del protocolo.
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 mb-3 mt-0">
        <div class="card card-fluid m-0">
          <div class="card-body">
            <label for="summary">Resumen</label>
            <textarea rows="5" cols="5" id="summary" name="summary" class="form-control"
                      v-model="protocol.summary"
                      disabled
                      ref="summary"></textarea>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="protocol">
      <div class="col-md-6">
        <div class="card card-fluid m-0">
          <div class="card-header">
            <div class="font-weight-bold">Financiadora(s):</div>
          </div>
          <div class="card-body">
            <funders-list :protocol="protocol"
                          :funders="protocol.funders"
                          v-if="protocol.funders.length"
                          class="list-group-flush"></funders-list>

            <div v-else>
              <p class="alert alert-warning">No se asignaron financiadoras al protocolo</p>
              <template v-if="protocol.financing_information">
                <p class="font-weight-bold">Justificación:</p>
                <textarea rows="5" cols="5" readonly disabled
                          class="form-control">{{protocol.financing_information.other_means}}</textarea>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="card card-fluid">
          <div class="card-header">
            <div class="font-weight-bold">Investigador(es) asignado(s):</div>
          </div>
          <div class="card-body">
            <researchers-list :researchers="researchers"
                              :protocol="protocol"
                              :show-header="false"
                              :show-actions="false"
                              ref="researchers-list"
                              v-if="researchers.length"
                              class="list-group-flush"></researchers-list>

            <div v-else>
              <p class="alert alert-warning">No se asignaron coinvestigadores al protocolo</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="mt-4 mx-auto">
          <form id="frm-evaluation"
                ref="frm-evaluation"
                accept-charset="UTF-8"
                class="card"
                method="GET"
                onsubmit="return false">

            <div class="card-header">
              <h1 class="card-title mb-0">{{ task.classification.title }}</h1>
            </div>
            <div class="card-body">
              <div class="form-group">
                <label class="d-block font-weight-normal">
                  ¿Valida el proyecto para su revisión?
                  <abbr style="text-decoration: none;"
                        title="Campo obligatorio">*</abbr>
                </label>
                <div class="custom-control custom-control-inline custom-radio">
                  <input id="project_validated_true"
                         v-model="status"
                         class="custom-control-input"
                         name="status"
                         type="radio"
                         value="aprobado">
                  <label class="custom-control-label"
                         for="project_validated_true">Sí</label>
                </div>
                <div class="custom-control custom-control-inline custom-radio">
                  <input id="project_validated_false"
                         v-model="status"
                         class="custom-control-input"
                         name="status"
                         type="radio"
                         value="rechazado">
                  <label class="custom-control-label"
                         for="project_validated_false">No</label>
                </div>
              </div>
              <div class="form-group">
                <label class="d-block font-weight-normal"
                       for="comments">
                  Observaciones:
                  <abbr style="text-decoration: none;"
                        title="Campo obligatorio">*</abbr>
                </label>
                <textarea id="comments"
                          v-model="comments"
                          class="form-control"
                          name="comments"
                          placeholder="Ingrese sus observaciones..."
                          rows="3"></textarea>
              </div>
            </div>
            <div class="card-footer d-flex py-2 px-2">
              <button class="btn btn-lg btn-primary mr-2"
                      type="submit">Enviar evaluación
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <portal to="modals">
      <ok-cancel-dialog id="accept-modal"
                        ref="accept-modal"
                        :ok-button-text="'Confirmar'"
                        content="<p>Por favor confirme el envio de su evaluación.</p>"
                        title="Confirmar envio"
                        @ok-button-pressed="acceptSend"></ok-cancel-dialog>
    </portal>
  </div>
</template>

<script>
  import 'jquery-validation'
  import OkCancelDialog from '../ui/OkCancelDialog'
  import ProtocolHeader from './ProtocolHeader'
  import FundersList from './FundersList'
  import ResearchersList from './ResearchersList'
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import { AlertManager } from '../utils/AlertManager'
  import autosize from 'autosize'

  export default {
    name: 'CenterDirectorEvaluation',
    components: {
      FundersList,
      OkCancelDialog,
      ProtocolHeader,
      ResearchersList,
    },
    data() {
      return {
        status: '',
        comments: '',
      }
    },
    props: {
      user: Object,
      protocol: Object,
      task: Object,
    },
    methods: {
      ...mapActions({
        sendEvaluation: 'protocols/saveDirectorEvaluation',
        getFunders: 'protocols/getProtocolFunders',
      }),

      ...mapMutations({
        setResearchers: 'protocols/SET_PROTOCOL_RESEARCHERS',
        setProtocol: 'protocols/SET_SELECTED_PROTOCOL',
      }),

      async acceptSend() {
        // Set loader in button.
        this.$refs['accept-modal'].sending = true

        // Send request.
        const response = await this.sendEvaluation({
          protocol: this.protocol.id,
          task: this.task.id,
          comments: this.comments,
          status: this.status,
        })
  
        const { status, error, message } = response.data.data
  
        if (status === 'error') {
          AlertManager.error(error)
          this.$refs['accept-modal'].sending = false
  
          return
        }
  
        AlertManager.success(message)

        this.$refs['accept-modal'].close()

        this.$emit('close-task')
      },
    },
    computed: {
      ...mapGetters({
        funders: 'protocols/funders',
        researchers: 'protocols/researchers',
      }),

      extraSmall() {
        return this.$mq === 'xs'
      },
      small() {
        return this.$mq === 'sm'
      },
      medium() {
        return this.$mq === 'md'
      },
      large() {
        return this.$mq === 'lg'
      },
      extraLarge() {
        return this.$mq === 'xl'
      },
    },
    async mounted() {

      autosize($('textarea'))
      
      this.setProtocol(this.protocol)

      if(this.protocol.researchers) {
        this.setResearchers(this.protocol.researchers)
      }

      /**
       * Init JQuery-validation
       */
      $('#frm-evaluation').validate({
        highlight: function(element, errorClass, validClass) {
          $(element).addClass('is-invalid')
        },
        unhighlight: function(element, errorClass, validClass) {
          $(element).removeClass('is-invalid')
        },
        errorPlacement: function(label, element) {
          label.addClass('invalid-feedback')

          if(element.is(':radio')) {
            label.insertAfter($('[data-name=\'' + element.attr('name') + '\']'))
          }
          else {
            label.insertAfter(element)
          }
        },
        rules: {
          status: {
            required: true,
          },
          comments: {
            required: true,
          },
        },
        messages: {
          status: {
            required: 'Este campo es requerido.',
          },
          comments: {
            required: 'Este campo es requerido.',
          },
        },
        submitHandler(form) {
          $('#accept-modal').modal('show')
        },
      })
    },
  }
</script>
